import { faEye } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Fragment, useEffect, useState } from "react";
import { Table } from "react-bootstrap";

import { deudasService } from "../../../../_services/deudas.service";
import { calcularMonto, calcularTotal, formatCapital } from "../../../../utils/utils";
import LoadingModal from "../../../../components/LoadingModal/LoadingModal";
import PlanDePagoModal from "../../../../components/PlanDePagoModal/PlanDePagoModal";
import { RecursosComercios } from "../../../../constants";
import "./RowDeudas.css";

export const RowDeudas = ({ record, inmuebles, abogados, situaciones = [] }) => {
  const [data, setData] = useState("");
  const [loading, setLoading] = useState("");

  const [showPlan, setShowPlan] = useState(false);
  const [planDePago, setPlanDePago] = useState(false);
  const [deudas, setDeudas] = useState([]);

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      try {
        let response = [];

        for (const e of RecursosComercios) {
          const resDeuda = await deudasService.getDeuda({
            imponible: record.NRO_COMERCIO,
            recurso: e
          });

          response.push({ ...resDeuda.data, recurso: e });
        }

        setData(response);
        setLoading(false);
      }
      catch (err) {
        setData("");
        setLoading(false);
      }
    };

    if (inmuebles) {
      setData("");
      getData();
    }
    else {
      setData(record);
    }

    return () => {
      setData("");
    };

  }, [inmuebles]);

  useEffect(() => {
    if (inmuebles) {
      setData("");
    }
    else {
      setData(record);
    }

    return () => {
      setData("");
    };

  }, [inmuebles]);

  function sliceByYear(arr) {
    let result = [];
    let temp = null;
    let tempIndx = 0;

    for (let i = 0; i < arr.length; i++) {
      if (temp && arr[i].ANIO !== temp) {
        let chunk = arr.slice(tempIndx, i);
        tempIndx = i;
        temp = arr[i].ANIO;

        result.push(chunk);
      }
      temp = arr[i].ANIO;
    }
    let chunk = arr.slice(tempIndx, arr.length);
    result.push(chunk);
    return result;
  }

  function formatDeudas(array) {
    if (array && array.length) {
      let resultSlice = sliceByYear(array);

      let result = resultSlice.reduce((a, b) => {
        b.forEach((e) => {
          const situacion = situaciones.find((s) => s.CODIGO === e.SITUACION);

          if (a[e.SITUACION]) {
            a[e.SITUACION] = {
              ...a[e.SITUACION],
              [e.ANIO]: {
                anio: e.ANIO,
                legal: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].legal ? a[e.SITUACION][e.ANIO].legal : e.LEGAL,
                periodos: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].periodos ? [...a[e.SITUACION][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
                monto: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].monto ? [...a[e.SITUACION][e.ANIO].monto, e.TOTAL] : [e.TOTAL],
                estado: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].estado ? [...a[e.SITUACION][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
                situacion: situacion.DETALLE_SITUACION
              }
            };
          }
          else {
            a[e.SITUACION] = {
              [e.ANIO]: {
                anio: e.ANIO,
                legal: e.LEGAL ? e.LEGAL : "",
                periodos: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].periodos ? [...a[e.SITUACION][e.ANIO].periodos, e.CUOTA] : [e.CUOTA],
                monto: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].monto ? [...a[e.SITUACION][e.ANIO].monto, e.TOTAL] : [e.TOTAL],
                estado: a[e.SITUACION] && a[e.SITUACION][e.ANIO] && a[e.SITUACION][e.ANIO].estado ? [...a[e.SITUACION][e.ANIO].estado, e.ESTADO] : [e.ESTADO],
                situacion: situacion.DETALLE_SITUACION
              }
            };
          }
        }
        );
        return a;
      }, {}
      );
      return result;
    } else {
      return false;
    }
  }

  useEffect(() => {
    if (data?.length) {
      const result = data.map((e) => {
        let deudas = formatDeudas(e.deuda);
        let legales = formatDeudas(e.legal);
        let planPago = e.planpago;
        let nroPlan = "";
        let deuda = "";
        let legal = [];
        let abogado = "";

        if (e.planpago) {
          nroPlan = e.planpago.reduce((prev, current) => {
            if (prev.length) {
              if (prev.some(e => e.NRO_PLAN === current.NRO_PLAN)) {
                return prev;
              }
              else {
                return [...prev, current];
              }
            }
            else {
              return [current];
            }
          }, []);
        }

        if (deudas && deudas["V"]) {
          deuda = Object.values(deudas["V"]);
        }
        if (legales) {
          if (legales[1]) {
            const a = Object.values(legales[1]);

            legal = a;
          }
          if (legales["G"]) {
            const b = Object.values(legales["G"]);

            legal = [...legal, ...b];
          }

          let abogadosList = legal.filter(e => e.legal);
          if (abogadosList?.length) {
            const findAbogado = abogados.find((e) => e.codexterno === abogadosList[abogadosList.length - 1].legal);
            abogado = `${findAbogado.apellido} ${findAbogado.nombre} (${findAbogado.codexterno})`;
          }
        }

        return {
          imponible: e.imponible,
          recurso: e.recurso,
          deudas,
          legales,
          planPago,
          nroPlan,
          deuda,
          legal,
          abogado
        };
      });

      if(result.length){
        let filtered = result.filter((e) => ((e.legal && e.legal.length) || (e.deuda && e.deuda.length) || (e.nroPlan && e.nroPlan.length)));
        setDeudas(filtered);
      }
      else{
        setDeudas(result);
      }
    }

    return () => {
      setDeudas([]);
    };
  }, [data]);

  const handleShow = (data) => {
    setPlanDePago(data);
    setShowPlan(true);
  };
  const handleClose = () => {
    setShowPlan(false);
  };

  return (
    <>
      {deudas?.length ? deudas.map((e, i) => {
        return (
          <div key={`${e.imponible}${e.recurso}${i}`} style={{ padding: 5 }}>
            {!loading && (
              <div style={{ border: "1px solid", borderRadius: 10, padding: 20 }}>
                <div>
                  <div>IMPONIBLE: <b>{e.imponible}</b></div>
                  <div>RECURSO: <b>{e.recurso}</b></div>
                </div>
                <div>
                  {e.legal && e.legal.length ? (
                    <Table className="subtable" striped bordered hover>
                      <tbody>
                        <tr>
                          <td colSpan={4} className="subtable-subtitulo">Períodos {e.abogado ? e.abogado : ""} en Gestión Legal</td>
                        </tr>
                        <tr>
                          <td className="subtable-key">Año</td>
                          <td className="subtable-key">Período</td>
                          <td className="subtable-key">Situación</td>
                          <td className="subtable-key">Monto</td>
                        </tr>
                        {e.legal.length && e.legal.map((deuda, i) => {
                          return <Fragment key={"deudas1-" + i}>
                            <tr>
                              <td><span>{deuda.anio}</span></td>
                              <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                              <td><span>{deuda.situacion}</span></td>
                              <td><span>$ {formatCapital(calcularMonto(deuda.monto))}</span></td>
                            </tr>
                          </Fragment>;
                        })
                        }
                        <tr>
                          <td colSpan={3} className="subtable-key">Total</td>
                          <td className="subtable-key">
                              $ {formatCapital(calcularTotal(e.legal))}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : null}

                  <br />
                  {e.deuda && e.deuda.length ? (
                    <Table className="subtable" striped bordered hover>
                      <tbody>
                        <tr>
                          <td colSpan={3} className="subtable-subtitulo">Períodos Fuera de Gestión Legal</td>
                        </tr>
                        <tr>
                          <td className="subtable-key">Año</td>
                          <td className="subtable-key">Período</td>
                          <td className="subtable-key">Monto</td>
                        </tr>
                        {e.deuda?.length && e.deuda.map((deuda, i) => {
                          return <Fragment key={"deudas2-" + i}>
                            <tr>
                              <td><span>{deuda.anio}</span></td>
                              <td><span>{deuda.periodos.map((p, i) => (i !== deuda.periodos.length - 1) ? p + ", " : p)}</span></td>
                              <td><span>$ {formatCapital(calcularMonto(deuda.monto))}</span></td>
                            </tr>
                          </Fragment>;
                        })}
                        <tr className="">
                          <td className="subtable-key"><span>Total</span></td>
                          <td></td>
                          <td className="subtable-key d-flex">
                            <span style={{ width: "100%" }}>
                                $ {formatCapital(calcularTotal(e.deuda))}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  ) : null}

                  <br />
                  {e.planPago?.length ? (
                    <Table className="subtable" striped bordered hover>
                      <tbody>
                        <tr>
                          <td colSpan={2} className="subtable-subtitulo">
                              PLANES DE PAGO
                          </td>
                        </tr>
                        {
                          e.nroPlan.length ? e.nroPlan.map((e, i) => {
                            return (
                              <tr key={e.NRO_PLAN + e.RECURSO + i}>
                                <td >
                                    NRO {e.NRO_PLAN}
                                </td>
                                <td>
                                  <FontAwesomeIcon
                                    icon={faEye}
                                    size="lg"
                                    className="ml-2"
                                    onClick={() => handleShow(e)}
                                  />
                                </td>
                              </tr>
                            );
                          })
                            : null
                        }
                      </tbody>
                    </Table>
                  ) : ""}
                </div>
              </div>
            )}
          </div>
        );
      }) : (
        <>
          <div className="d-flex justify-content-center" style={{ fontSize: 18 }}>
            No posee deudas
          </div>
        </>
      )}

      {loading ? <LoadingModal show={loading} loading={true} /> : null}
      {showPlan ? <PlanDePagoModal show={showPlan} handleClose={handleClose} data={planDePago} imponible={record.NRO_INMUEBLE} recurso={record.RECURSO} /> : null}
    </>
  );
};